<div class="matrix_layoutMain container"  v-bind:class="getClassNameContainer">
    <div class="row">
        <div class="col-md-12" >     
            <!-- <appQuantitySelectionContainer></appQuantitySelectionContainer>             -->
            <appCostCenter></appCostCenter>
            <appQuantityTable>
                <appQuantityContainer></appQuantityContainer>
                <appInputQuantity></appInputQuantity>
            </appQuantityTable>
            <appUploadTable alwaysShow=true></appUploadTable>
            <div class="matrix_summaryInformation">
                <appFactsheet></appFactsheet>
            </div>
            <appAddToCartButton></appAddToCartButton>                           
        </div>
    </div>    
</div>